import { render, staticRenderFns } from "./Adm_destino.vue?vue&type=template&id=c80dff7c"
import script from "./Adm_destino.vue?vue&type=script&lang=js"
export * from "./Adm_destino.vue?vue&type=script&lang=js"
import style0 from "./Adm_destino.vue?vue&type=style&index=0&id=c80dff7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports